import React from "react";
import { Avatar, Tooltip } from "@mui/material";

const GRADIENTS = [
  "linear-gradient(135deg, #534AB7, #8b7fe8)",
  "linear-gradient(135deg, #1D9E75, #5DCAA5)",
  "linear-gradient(135deg, #D85A30, #F0997B)",
  "linear-gradient(135deg, #BA7517, #EF9F27)",
  "linear-gradient(135deg, #185FA5, #378ADD)",
  "linear-gradient(135deg, #9B2C8E, #D46BC4)",
  "linear-gradient(135deg, #2D8C6F, #4DBFA0)",
  "linear-gradient(135deg, #C73E3E, #E87676)",
  "linear-gradient(135deg, #3A6BA5, #6E9FD8)",
  "linear-gradient(135deg, #767676, #A0A0A0)",
];

export const getInitials = (name) => {
  if (!name) return "?";
  return name.split(" ").filter(Boolean).map((w) => w[0]).join("").slice(0, 2).toUpperCase();
};

export const gradientForId = (id) => GRADIENTS[(Number(id) || 0) % GRADIENTS.length];

const UserAvatar = React.forwardRef(({ user, size = 36, ring, sx, tooltip = true, ...rest }, ref) => {
  const label = user?.full_name || user?.email;
  const avatar = (
    <Avatar
      ref={ref}
      src={user?.picture_url || undefined}
      sx={{
        width: size,
        height: size,
        fontSize: size * 0.38,
        fontFamily: "Segoe UI Semibold, sans-serif, system-ui",
        color: "#ffffff",
        background: gradientForId(user?.id),
        flexShrink: 0,
        ...(ring ? { boxShadow: `0 0 0 2px #ffffff, 0 0 0 4px ${ring}` } : {}),
        ...sx,
      }}
      {...rest}
    >
      {getInitials(label)}
    </Avatar>
  );

  if (tooltip && label) {
    return (
      <Tooltip title={label} arrow placement="top">
        {avatar}
      </Tooltip>
    );
  }

  return avatar;
});

UserAvatar.displayName = "UserAvatar";

export default UserAvatar;
